import { Utility } from 'src/app/shared/utility';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { GridComponent, RowArgs } from '@progress/kendo-angular-grid';
import { State, CompositeFilterDescriptor, process } from '@progress/kendo-data-query';
import { UsersService } from 'src/app/shared/services/common/users.service';
import { DocumentService } from 'src/app/shared/services/documents/document.service';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { EmployeesService } from 'src/app/shared/services/employees/employees.service';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { DisplayNotificationService } from 'src/app/shared/services/common/notification.service';

@Component({
  selector: 'app-invoice-details',
  templateUrl: './invoice-details.component.html',
  styleUrls: ['./invoice-details.component.css']
})
export class InvoiceDetailsComponent implements OnInit {
  dataItem: any;
  gridData: any;
  type: any;
  cssId: string;
  state: State = {
    skip: 0,
    take: 10,
    sort: [],
    filter: {
      logic: "and",
      filters: [],
    },
    group: [{ field: "groupType" }]
  };
  filters: CompositeFilterDescriptor;
  sort: any;
  show: boolean;
  selectedIds = [];
  @Output() selected = new EventEmitter();
  @Output() dateChange = new EventEmitter();
  @ViewChild(GridComponent) grid: GridComponent;
  isRowSelected: (e: RowArgs) => boolean;
  errorLoading: boolean;
  selectedItems = [];
  showDifferedDt: boolean;
  showDateValidation: boolean;
  dateError: any;
  paymentCutOffTime: any;
  currentDate: any;
  minDifDt: any;
  showScheduledColumn: boolean;

  @Input() set invoiceDetails(data: any) {
    if (data) {
      this.dataItem = data;
      this.setDataItem();
    }
  }
  @Input() set reset(record: any) {
    if (record) {
      this.resetSelection();
    }
  }
  @Input() canSelect: boolean;
  @Input() set configTxt(msg: any) {
    this.dateError = msg.DateError;
    this.paymentCutOffTime = msg.PaymentCutOffTime;
  }
  showDialog = false;
  dialogData: any;
  constructor(
    private notificationService: DisplayNotificationService,
    private authService: AuthService,
    private usersService: UsersService,
    private documentService: DocumentService,
    private employeeService: EmployeesService) {
    this.allData = this.allData.bind(this);
  }

  ngOnInit() {
    this.showScheduledColumn = this.authService.getDarkKeyValue('Invoice Schedule Date');
    setTimeout(() => this.setStyle(), 2000);
  }

  allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: this.dialogData
    };
    return result;
  }

  setStyle() {
    const cells = document.querySelectorAll('.k-group-cell');
    cells.forEach(
      e => {
        e.classList.add('border-none');
      }
    )
  }

  setDataItem() {
    this.gridData = this.dataItem.data;
    this.gridData.data.forEach((element) => {
      element.formatAmount = Utility.checkNegativeAmount(element.amount);
    });
    this.type = this.dataItem.invoiceType;
    if (this.type === 'Due') {
      this.selectedItems = [];
      this.gridData.data.forEach(x => {x.scheduledDate = undefined; x.showDateError = false; });
    }
    this.cssId = this.dataItem.id;
    this.errorLoading = this.dataItem.error;
    this.show = true;
    this.currentDate = new Date();
    this.minDifDt = new Date();
    this.isRowSelected = (e: RowArgs) => this.selectedIds.indexOf(e.dataItem.id) >= 0;
  }

  viewInvoice(data: any) {
    if (this.type === 'Paid') {
      const inputData = {
        userInfo: this.usersService.UserInfo(),
        fileName: data.invoiceNumber + '.pdf',
        Id: data.id
      };
      this.documentService.viewPaidInvoice(inputData).subscribe(() => {
        data.isClicked = !data.isClicked;
      },
        (err: HttpErrorResponse) => {
          console.log(err);
          data.isClicked = !data.isClicked;
        });
    } else {
      const inputData = {
        userInfo: this.usersService.UserInfo(),
        Id: data.id
      };
      this.documentService.viewInvoice(inputData, data.invoiceNumber).subscribe(() => {
        data.isClicked = !data.isClicked;
      },
        (err: HttpErrorResponse) => {
          console.log(err);
          data.isClicked = !data.isClicked;
        });
    }
  }

  onSelectionChange(event: any) {
    let selectedItem;
    if (event.selectedRows.length > 0) {
      selectedItem = event.selectedRows[0].dataItem;
      this.selectedItems.push(selectedItem);
      this.selectedIds.push(selectedItem.id);
    } else if (event.deselectedRows.length > 0) {
      const deSelectedId = event.deselectedRows[0].dataItem.id;
      const index = this.selectedIds.indexOf(deSelectedId);
      this.gridData.data.forEach(x => {
        if (x.id === deSelectedId) {
          x.scheduledDate = undefined;
          x.showDateError = false;
        }
      }
      );
      this.selectedIds.splice(index, 1);
      this.selectedItems.splice(index, 1);
      this.selectedItems.forEach(element => {
        if (element.amount > 0) {
          this.showDifferedDt = this.selectedItems.length > 0;
        }
      });
      this.showDifferedDt = false;
    }
    if (this.type === 'Due' && this.selectedItems.length > 0) {
      this.selectedItems.forEach((element: any) => {
        if (element.amount > 0) {
          const dueDate: any = new Date(element.dueDate);
          const todayDate = new Date();
          let tmrwDate = new Date();
          tmrwDate = new Date(tmrwDate.setDate(this.currentDate.getDate() + 1));
          if ((dueDate - this.currentDate) > 60000) {
            if (dueDate.toLocaleDateString() !== tmrwDate.toLocaleDateString()) {
              this.showDifferedDt = true;
              if (selectedItem && selectedItem.id === element.id) {
                if (this.currentDate.getHours() < this.paymentCutOffTime) {
                  element.scheduledDate = this.currentDate;
                } else {
                  element.scheduledDate = tmrwDate;
                  this.minDifDt = new Date(todayDate.setDate(this.currentDate.getDate() + 1));
                }
              }
            } else {
              if (this.currentDate.getHours() < this.paymentCutOffTime) {
                this.showDifferedDt = true;
                element.scheduledDate = this.currentDate;
              } else {
                element.scheduledDateAfterCutoff = tmrwDate;
              }
            }
          }
        } else {
          element.dueDate = this.currentDate;
        }
      });
    }
    this.showDateValidation = this.selectedItems.some(x => x.showDateError);
    this.selected.emit({ selectionEvent: event, isDateError: this.showDateValidation });
    this.isRowSelected = (e: RowArgs) => this.selectedIds.indexOf(e.dataItem.id) >= 0;
  }

  onDateChange(e: any) {
    if (e.isSchedulable && e.scheduledDate !== null) {
      const value = new Date(e.scheduledDate.toLocaleDateString());
      const isValidDate = (value !== null && (value.valueOf() > 0 &&
        value.valueOf() >= new Date(this.minDifDt.toDateString()).valueOf() && value.valueOf() <= new Date(e.dueDate).valueOf()));
      e.showDateError = !isValidDate;
      this.showDateValidation = this.selectedItems.some(x => x.showDateError);
      this.dateChange.emit({selectionEvent: e, isDateError: this.showDateValidation });
    }
  }

  getMaxDt(date: any) {
    return this.minDifDt > new Date(date) ? this.minDifDt : new Date(date);
  }

  resetSelection() {
    this.selectedIds = [];
    this.selectedItems = [];
    this.showDifferedDt = this.selectedItems.length > 0;
    this.gridData.data.forEach(x => {x.scheduledDate = undefined; x.showDateError = false; });
    this.isRowSelected = (e: RowArgs) => this.selectedIds.indexOf(e.dataItem.id) >= 0;
  }

  openDialog(id: any) {
    this.showDialog = true;
    this.employeeService.getEnrollmentSalaryData({ userInfo: this.usersService.UserInfo(), invoiceId: id }).subscribe(res => {
      if (res && res.success == true) {
        this.dialogData = res.salaryData;
      } else {
        this.notificationService.setErrorNotification();
      }
    },
      (err: HttpErrorResponse) => {
        this.notificationService.setErrorNotification();
        console.log(err);
      });
  }

  onCancel() {
    this.showDialog = false;
  }
}
